import { ref } from 'vue'

export default function useDialog() {
  const visible = ref(false)

  function show() {
    visible.value = true
  }

  function hide() {
    visible.value = false
  }

  return {
    visible,
    show,
    hide,
  }
}
